import { MappingDisplayType } from "Enums";
import { Mapping, App } from "Core";
import { IBaseGrid } from "Grids/Interfaces";
import { Page, MappingPage } from "Core/Pages";

/**
 * @hidden
 */
export class PageContext {
    private static getPage(): Page {
        if (App.current && App.current.router) {
            return App.current.router.currentPage;
        }
        return undefined;
    }

    private static getMappingPage(): MappingPage {
        const page = this.getPage();

        if (page instanceof MappingPage) {
            return page;
        }
        return null;
    }

    public static setAllowPageTokenRelease(value: boolean): void {
        this.getPage().allowPageTokenRelease = value;
    }

    public static getMappingName(): string {
        let mappingPage = this.getMappingPage();
        if (mappingPage) {
            return mappingPage.mappingName;
        }
    }

    public static getPageToken(): string {
        return this.getPage().pageToken;
    }

    public static reloadGrids(reloadFilters: boolean): void {
        this.getMappingPage().reloadGrids(reloadFilters);
    }

    public static hideGrids(clearGrid: boolean = true): void {
        this.getMappingPage().hideGrids(clearGrid);
    }

    public static getFilterParameters(): { [key: string]: any } {
        let mappingPage = this.getMappingPage();
        if (mappingPage) {
            return mappingPage.getFilterParameters();
        }
        return {};
    }

    public static getGrids(): IBaseGrid[] {
        return this.getMappingPage().getGrids();
    }

    public static removeAdditionalMapping(mapping: Mapping): void {
        this.getMappingPage().removeAdditionalMapping(mapping);
    }

    public static initializeMappingInContainer(
        container: JQuery,
        mappingName: string,
        displayType: MappingDisplayType = MappingDisplayType.FilterAndGrids
    ): Promise<Mapping> {
        return this.getMappingPage().initializeMappingInContainer(container, mappingName, displayType);
    }

    public static resizePage(): void {
        let page = this.getPage();
        if (page) {
            page.resize();
        }
    }

    public static getFilter(): IBaseGrid {
        return this.getMappingPage().getFilter();
    }

    public static getCurrentTextBlockCategory(): string {
        return this.getPage().currentTextBlockCategory;
    }
}
